import { EVENT } from "@/tracking_events";

export const recentEventType: Record<string, string> = {
  [EVENT["CREATED_REPORT"]]:
    L.DASHBOARD__COLLEAGUES__LATEST_ACTIVITY__CREATED_REPORT,
  [EVENT["CREATED_ALERT"]]:
    L.DASHBOARD__COLLEAGUES__LATEST_ACTIVITY__CREATED_ALERT,
  [EVENT["DELETED_ALERT"]]:
    L.DASHBOARD__COLLEAGUES__LATEST_ACTIVITY__DELETED_ALERT,
  [EVENT["EDITED_ALERT"]]:
    L.DASHBOARD__COLLEAGUES__LATEST_ACTIVITY__EDITED_ALERT,
  [EVENT["SAVE_MENTIONS"]]:
    L.DASHBOARD__COLLEAGUES__LATEST_ACTIVITY__SAVE_MENTIONS,
  [EVENT["EXPORT_MENTIONS_TO_EXCEL"]]:
    L.DASHBOARD__COLLEAGUES__LATEST_ACTIVITY__EXPORT_MENTIONS_TO_EXCEL,
  [EVENT["EXPORT_MENTIONS_TO_CSV"]]:
    L.DASHBOARD__COLLEAGUES__LATEST_ACTIVITY__EXPORT_MENTIONS_TO_CSV,
  [EVENT["SHARED_MENTION"]]:
    L.DASHBOARD__COLLEAGUES__LATEST_ACTIVITY__SHARED_MENTION,
  [EVENT["MARKED_MENTION_RELEVANT"]]:
    L.DASHBOARD__COLLEAGUES__LATEST_ACTIVITY__MARKED_MENTION_RELEVANT,
  [EVENT["MARKED_MENTION_IRRELEVANT"]]:
    L.DASHBOARD__COLLEAGUES__LATEST_ACTIVITY__MARKED_MENTION_IRRELEVANT,
  [EVENT["ADDED_MENTION_TAG"]]:
    L.DASHBOARD__COLLEAGUES__LATEST_ACTIVITY__ADDED_MENTION_TAG,
  [EVENT["REMOVED_MENTION_TAG"]]:
    L.DASHBOARD__COLLEAGUES__LATEST_ACTIVITY__REMOVED_MENTION_TAG,
  [EVENT["PLAYED_MENTION"]]:
    L.DASHBOARD__COLLEAGUES__LATEST_ACTIVITY__PLAYED_MENTION,
  [EVENT["DID_SEARCH"]]: L.DASHBOARD__COLLEAGUES__LATEST_ACTIVITY__DID_SEARCH,
  [EVENT["USER_ACTIVATED"]]:
    L.DASHBOARD__COLLEAGUES__LATEST_ACTIVITY__USER_ACTIVATED,
  [EVENT["INVITED_COLLEAGUE"]]:
    L.DASHBOARD__COLLEAGUES__LATEST_ACTIVITY__INVITED_COLLEAGUE,
  [EVENT["SETTINGS_UPDATED"]]:
    L.DASHBOARD__COLLEAGUES__LATEST_ACTIVITY__SETTINGS_UPDATED,
  [EVENT["USER_DELETED"]]:
    L.DASHBOARD__COLLEAGUES__LATEST_ACTIVITY__USER_DELETED,
  [EVENT["CREATED_REPORT_FROM_TEMPLATE"]]:
    L.DASHBOARD__COLLEAGUES__LATEST_ACTIVITY__CREATED_REPORT_FROM_TEMPLATE,
  [EVENT["PDF_GENERATED"]]:
    L.DASHBOARD__COLLEAGUES__LATEST_ACTIVITY__PDF_GENERATED,
  [EVENT["EDIT_REPORT"]]: L.DASHBOARD__COLLEAGUES__LATEST_ACTIVITY__EDIT_REPORT,
};
